import { i18n } from '@/plugins/i18n'


export const ShaparakDownloadedFileTypes = {
     SWITCH : 1,
     ANNOUNCEMENT: 2,
     RETURNED : 3,
     REP : 4,
}

export const ShaparakDownloadedFileTypesStr = {
     SWITCH : i18n.t('reports.terminals.shaparak_files.switch'),
     ANNOUNCEMENT : i18n.t('reports.terminals.shaparak_files.announcement'),
     RETURNED : i18n.t('reports.terminals.shaparak_files.returned'),
     REP : i18n.t('reports.terminals.shaparak_files.rep'),
     get(file_type) {
          let file_type_str = null;
          Object.keys(ShaparakDownloadedFileTypes).forEach(function (item) {
               if(ShaparakDownloadedFileTypes[item] === file_type) {
                    file_type_str = ShaparakDownloadedFileTypesStr[item]
               }
          })

          return file_type_str
     }
}

export const shaparakTypeVariant = (type) => {
     let variant = '';
     if (type === ShaparakDownloadedFileTypes.SWITCH) variant = 'success'
     else if (type === ShaparakDownloadedFileTypes.ANNOUNCEMENT) variant = 'warning'
     else if (type === ShaparakDownloadedFileTypes.RETURNED) variant = 'primary'
     else if (type === ShaparakDownloadedFileTypes.REP) variant = 'danger'
     return variant;
}